/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerCompanyUpdateTypeRequest
 */
export interface FreelancerCompanyUpdateTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyUpdateTypeRequest
     */
    newCompanyTypeId: string;
}

/**
 * Check if a given object implements the FreelancerCompanyUpdateTypeRequest interface.
 */
export function instanceOfFreelancerCompanyUpdateTypeRequest(value: object): value is FreelancerCompanyUpdateTypeRequest {
    if (!('newCompanyTypeId' in value) || value['newCompanyTypeId'] === undefined) return false;
    return true;
}

export function FreelancerCompanyUpdateTypeRequestFromJSON(json: any): FreelancerCompanyUpdateTypeRequest {
    return FreelancerCompanyUpdateTypeRequestFromJSONTyped(json, false);
}

export function FreelancerCompanyUpdateTypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerCompanyUpdateTypeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'newCompanyTypeId': json['newCompanyTypeId'],
    };
}

export function FreelancerCompanyUpdateTypeRequestToJSON(value?: FreelancerCompanyUpdateTypeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'newCompanyTypeId': value['newCompanyTypeId'],
    };
}

